
import WebFont from 'webfontloader'

const options = {"typekit":{"id":"zad2sye"}}

WebFont.load(options)
